import {
  OrderStockArticle,
  StockArticleAction,
  StockArticleActions,
  UpsertStockArticle
} from './../model';

export function fetchStockArticles(
  customerId: string,
  category?: string
): StockArticleAction {
  return {
    type: StockArticleActions.FETCH_CUSTOMER_ARTICLES,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerId}${category ? `?category=${category}` : ''}`,
        method: 'GET',
      },
    },
  };
}

export function fetchStockArticleItems(
  customerId: string,
  articleId: number
): StockArticleAction {
  return {
    type: StockArticleActions.FETCH_CUSTOMER_ARTICLE_ITEMS,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerId}/${articleId}/items`,
        method: 'GET',
      },
    },
  };
}

export function fetchStockArticleEvents(
  customerId: string,
  articleId: number
): StockArticleAction {
  return {
    type: StockArticleActions.FETCH_CUSTOMER_ARTICLE_EVENTS,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerId}/${articleId}/events`,
        method: 'GET',
      },
    },
  };
}

export function createStockArticle(
  article: UpsertStockArticle,
  customerId: string
): StockArticleAction {
  return {
    type: StockArticleActions.CREATE_CUSTOMER_ARTICLE,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerId}`,
        method: 'POST',
        data: article,
      },
    },
  };
}

export function updateStockArticle(
  customerId: string,
  article: UpsertStockArticle
): StockArticleAction {
  return {
    type: StockArticleActions.UPDATE_CUSTOMER_ARTICLE,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerId}/${article.id}`,
        method: 'PUT',
        data: article,
      },
    },
  };
}

export function orderStockArticle(
  customerId: string,
  article: OrderStockArticle
): StockArticleAction {
  return {
    type: StockArticleActions.ORDER_CUSTOMER_ARTICLE,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerId}/${article.id}/order`,
        method: 'POST',
        data: article,
      },
    },
  };
}

export function deleteStockArticle(
  customerId: string,
  id: string | number
): StockArticleAction {
  return {
    type: StockArticleActions.DELETE_CUSTOMER_ARTICLE,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerId}/${id}`,
        method: 'DELETE',
      },
    },
  };
}

export function fetchFilter(search?: string) {
  return {
    type: StockArticleActions.FETCH_FILTER,
    payload: {
      request: {
        url: '/articles/filter?search=' + (search || ''),
        method: 'GET',
      },
    },
  };
}

export function triggerOldStockExport(): StockArticleAction {
  return {
    type: StockArticleActions.TRIGGER_STOCK_EXPORT,
    payload: {
      request: {
        url: '/stock-articles/old-stock/export',
        method: 'POST',
      },
    },
  };
}
